// extracted by mini-css-extract-plugin
module.exports = {"infoNote":"AddIntakeSessionDialog_infoNote__3DccF"};